module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contact","email":"Email","message":"Message","send":"Send"},"tr":{"title":"İletişim","email":"Eposta","message":"Mesaj","send":"Gönder"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/view/pages/Contact/i18n/index.json
// module id = +k33
// module chunks = 1